(function(){
    'use strict'

    angular
    .module('app.permisos')
    .controller('Permisos', Permisos);

    Permisos.$inject = ['$animationsSrv', '$routeParams', 'PermisosService', 'logger', '$location'];

    function Permisos($animationsSrv, $routeParams, PermisosService, logger, $location) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.permisos = [];
        vm.permisosCompania = [];
        vm.permisosTiposPlanilla = [];
        vm.title = 'Permisos';

        var grupoId = $routeParams.id ? $routeParams.id : 0;

        getAll();
        getAllCompanias();
        getAllTiposPlanilla();

        vm.goToGrupo = function(grupo){
            
            var path = '/editar-grupo/';

            if(grupo){
                $location.path(path + grupo.id);
            }
            else{
                $location.path(path);
            }
            
        };

        function getAll(){

            var promise = PermisosService.getAll(grupoId);

            promise
            .then(function(permisos){
                vm.permisos = permisos;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los permisos.');
                        break;
                }
            });
        };

        function getAllCompanias(){

            var promise = PermisosService.getAllCompanias(grupoId);

            promise
            .then(function(permisosCompania){
                vm.permisosCompania = permisosCompania;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los permisos de compañias.');
                        break;
                }
            });
        };

        function getAllTiposPlanilla(){

            var promise = PermisosService.getAllTiposPlanilla(grupoId);

            promise
            .then(function(permisosTiposPlanilla){
                vm.permisosTiposPlanilla = permisosTiposPlanilla;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los permisos de tipos de planilla.');
                        break;
                }
            });
        };

        vm.saveAll = function(){
            save();
            saveCompanias();
            saveTiposPlanilla();
        };

        function save(){

            var promise = PermisosService.save(grupoId, vm.permisos);
            
            promise
            .then(function(response){
                logger.success('Permisos guardados con éxito.');
            })
            .catch(function(error){
                logger.error('Hubo un error al actualizar los datos');
            });               
        };

        function saveCompanias(){

            var promise = PermisosService.saveCompanias(vm.permisosCompania);
            
            promise
            .then(function(response){
                logger.success('Permisos de Compañias guardadas con éxito.');
            })
            .catch(function(error){
                logger.error('Hubo un error al actualizar los datos');
            });               
        };

        function saveTiposPlanilla(){

            var promise = PermisosService.saveTiposPlanilla(vm.permisosTiposPlanilla);
            
            promise
            .then(function(response){
                logger.success('Permisos de Tipos de Planilla guardados con éxito.');
            })
            .catch(function(error){
                logger.error('Hubo un error al actualizar los datos');
            });               
        };

    }
})();